// Centralized route

export const ROUTES = {
  FAIRGEN_AI_STUDIO: '/fairgen-ai-studio',
  PERSONAS_SELECTION: '/fairgen-ai-studio/personas',
  ART_STYLES_SELECTION: '/fairgen-ai-studio/art-styles',
} as const;
